<template>
  <div class="d-flex" v-if="item">
    <div class="d-flex border-dashed rounded" style="background: #F5F8FA">
      <div class="cursor-pointer border-right border-1 rounded-left px-4 py-2"
           :class="{ 'bg-primary fw-bolder' : value === true }" @click="setValue(true)">
        Oui
      </div>
      <div class="cursor-pointer rounded-right px-4 py-2"
           :class="{ 'bg-primary fw-bolder' : value === false }" @click="setValue(false)">
        Non
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class PropertyBoolean extends Vue {
  @Prop() itemUuid!: string
  @Prop() propertyCode!: string
  @Prop({default: false}) isDisabled!: boolean

  get item() {
    return this.$store.getters["contractStore/getEntity"]('items', this.itemUuid)
  }

  get value() {
    const v = this.item?.properties?.[this.propertyCode]
    if (v === 'true') return true
    if (v === 'false') return false
    return v
  }

  set value(v: any) {
    if (this.item) {
      Vue.set(this.item.properties, this.propertyCode, v)
    }
  }

  mounted() {
    const v = this.item?.properties?.[this.propertyCode]
    if (v === 'true' || v === 'false') {
      this.value = v === 'true'
    }
  }

  setValue(val: boolean) {
    if (this.isDisabled) return
    this.value = val
    this.$emit('propertyUpdated', {code: this.propertyCode, itemUuid: this.itemUuid})
  }
}
</script>

<style scoped>
</style>
